// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6261bda8479fcfc5","5405":"46ab514ad8b4320d","8053":"46ab514ad8b4320d"}[chunkId] + ".css";
};